import React from "react";

export const setEmailBodyConfirmPayment = (props) => {
    const { formValues, eventValues, urlArchivo, aditionalData } = props;
    // console.log(formValues, eventValues);
    const styles = {
        p: { border: "1px solid gray", width: "380px", backgroundColor: "#ddd" },
        div: {
            border: "1px solid gray",
            width: "380px",
            padding: "0 20px",
            margin: "10px 6px",
            backgroundColor: "#ddd",
        },
        divWhite: {
            textAlign: "center",
            width: "380px",
            padding: "0 20px",
            margin: "10px 6px",
            backgroundColor: "#fff",
        },
        divWhiteNoMargin: {
            textAlign: "center",
            width: "380px",
            padding: "0 20px",
            backgroundColor: "#fff",
        },
        divWhiteNoPadding: {
            textAlign: "center",
            width: "380px",
            margin: "10px 6px",
            backgroundColor: "#fff",
        },
        divWhiteLeft: {
            border: "1px solid gray",
            width: "380px",
            padding: "0 20px",
            margin: "10px 6px",
            backgroundColor: "#fff",
        },
        divWhiteLeftNoBorder: {
            width: "380px",
            padding: "10px 20px",
            margin: "10px 6px",
            backgroundColor: "#fff",
        },
        li: { padding: "6px 0" },
    };

    // Setea el html que va a insertar de acuerdo a si es extranjero o no, y si requiere factura o no
    let facturaValue = '';
    if (formValues.factExtranjero) {
        facturaValue = 
            <div style={styles.divWhiteLeft}>
                <p>Facturación: <br /><br />
                    Pais: {formValues.factExtPais}<br />
                    Nombre a facturar: {formValues.factExtNombre}<br />
                    Concepto: {formValues.factExtConcepto}<br />
                </p>
            </div>;
    } else {
        // Es nacional
        if ( formValues.requiereFactura ) {
            facturaValue = 
            <div style={styles.divWhiteLeft}>
                <p>Facturación: <strong>SI requiere factura</strong><br /><br />
                    Nombre a facturar: {formValues.factNombre}<br />
                    RFC: {formValues.factRFC}<br />
                    C.P.: {formValues.factCP}<br />
                    Uso CFDI (clave): {formValues.factUsoCFDI}<br />
                    Regimen fiscal (clave): {formValues.factRegimenFiscal}<br />
                </p>
            </div>;
        } else {
            facturaValue = 
            <div style={styles.divWhiteLeft}>
                <p>Facturación: <strong>NO requiere factura</strong></p>
            </div>;
        }
    }

    return (
        <>
            {/* Logo */}
            <div style={styles.divWhite}>
                <img src={eventValues.urlLogo} alt="logo" width={120} />
            </div>
            {/* Titulo */}
            <div style={styles.divWhite}>
                <h2>{eventValues.tituloEvento}</h2>
            </div>
            {/* Numero de referencia */}
            <div style={styles.divWhite}>
                <h3>¡Su comprobante de pago ha sido recibido con éxito!</h3>
                <h2>
                    Numero de referencia: <br />
                    {formValues.registroReferencia}
                </h2>
            </div>
            {/* Enlace al comprobante */}
            <div style={styles.divWhite}>
                <a href={urlArchivo}>
                    <button>
                        <h3>Consultar comprobante ingresado</h3>
                    </button>
                </a>
            </div>
            {/* Datos personales */}
            <div style={styles.divWhiteLeft}>
                <ul>
                    <li style={styles.li}>Nombre completo: <strong>{`${formValues.partNombres} ${formValues.partApellidoPaterno} ${formValues.partApellidoMaterno}`}</strong>
                    </li>
                    <li style={styles.li}>Extranjero: <strong>{ (formValues.factExtranjero) ? `Si` : `No` }</strong>
                    </li>
                </ul>
            </div>
            {/* Datos para facturar */}
            {facturaValue}
            {/* Inf. adicional */}
            <div style={styles.divWhiteLeft}>
                <div dangerouslySetInnerHTML={{ __html: aditionalData }} />
            </div>

            {/* Footer */}
            <div style={styles.divWhiteLeftNoBorder}>
                <strong>
                    <i>
                        Atentamente,
                        <br />
                        Comité organizador
                    </i>
                </strong>
            </div>
        </>
    );
};
